import React from "react";
import PayCreditCard from "./PayCreditCard";

const PayCheque = () => <PayCreditCard chequeMode />;

export default PayCheque;
